import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../auth/supabase';
import { apiFetch } from '../api/client';
import styles from './PatientsList.module.css';
import NewPatientWizard from '../components/NewPatientWizard';

export default function PatientsList() {
  const [patients, setPatients] = useState([]);
  const [q, setQ] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [showWizard, setShowWizard] = useState(false);

  const getToken = async () => (await supabase.auth.getSession()).data.session?.access_token;

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await apiFetch('/patients', {}, getToken);
        setPatients(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = patients.filter((p) => {
    const t = `${p.mrn || ''} ${p.full_name || ''}`.toLowerCase();
    return t.includes(q.toLowerCase());
  });

  return (
    <div className={styles.page}>
      <div className={styles.bar}>
        <input className={styles.search} placeholder="Search by MRN or name" value={q} onChange={(e) => setQ(e.target.value)} />
        <button className={styles.button} onClick={() => setShowWizard(true)}>+ New Patient</button>
      </div>
      {loading ? (
        <div className={styles.info}>Loading...</div>
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : filtered.length === 0 ? (
        <div className={styles.info}>No patients yet</div>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>MRN</th>
                <th>Full Name</th>
                <th>Age</th>
                <th>Sex</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((p) => (
                <tr key={p.id}>
                  <td><Link className={styles.link} to={`/patients/${p.id}`}>{p.mrn || '-'}</Link></td>
                  <td>{p.full_name}</td>
                  <td>{p.age ?? '-'}</td>
                  <td>{p.sex ?? '-'}</td>
                  <td>{new Date(p.updated_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showWizard && <NewPatientWizard onClose={() => setShowWizard(false)} />}
    </div>
  );
}
